/**
 * WKZ-Codes (Wagniskennziffern) for the KFZ step form.
 * Sourced from the "WKZs" sheet of the
 * "1+2 Risiko KFZ Analyse, Risikomaske & Vertragsmaske - 2025 11 25.xlsx"
 * business-logic spec (56 codes).
 *
 * The plan is to auto-fill this field from a future Generali data feed.
 * Until that integration is wired, the form offers manual selection from
 * this full list.
 */
export type WkzCode = {
  code: string;
  label: string;
};

export const WKZ_CODES: WkzCode[] = [
  { code: "014", label: "Leichtkraftroller" },
  { code: "024", label: "Leichtkraftkrafträder" },
  { code: "003", label: "Krafträder und Kraftroller" },
  { code: "030", label: "Trikes" },
  { code: "031", label: "Quads" },
  { code: "072", label: "Selbstfahrervermietkrafträder" },
  { code: "112", label: "Pkw" },
  { code: "140", label: "Mietwagen" },
  { code: "150", label: "Taxis" },
  { code: "162", label: "Selbstfahrervermiet-Pkw" },
  { code: "127", label: "Wohnmobile (Campingfahrzeuge)" },
  { code: "172", label: "Selbstfahrervermiet-Wohnmobile" },
  { code: "541", label: "Wohnwagenanhänger" },
  { code: "251", label: "Lieferwagen Privat- und Werkverkehr" },
  { code: "261", label: "Lieferwagen Gewerblicher Güterverkehr" },
  { code: "272", label: "Selbstfahrervermiet-Lieferwagen" },
  { code: "351", label: "Lastkraftwagen Werkverkehr" },
  { code: "361", label: "Lastkraftwagen Gewerblicher Güterverkehr" },
  { code: "359", label: "Lehr-Lkw" },
  { code: "382", label: "Lkw im Umzugsverkehr" },
  { code: "372", label: "Selbstfahrervermiet-Lastkraftwagen" },
  { code: "401", label: "Zugmaschine Werkverkehr" },
  { code: "411", label: "Zugmaschine Gewerblicher Güterverkehr" },
  { code: "451", label: "Landwirtschaftlicher Zugmaschine und Raupenschlepper" },
  { code: "581", label: "Anhänger Privat- und Werkverkehr" },
  { code: "591", label: "Anhänger Gewerblicher Güterverkehr" },
  { code: "532", label: "Anhänger Umzugsverkehr" },
  { code: "551", label: "Anhänger zu landwirtschaftlichen Zugmaschinen" },
  { code: "542", label: "Anhänger in Sonderausführung" },
  { code: "561", label: "Anhänger von Fahrzeugen des Deutschen Roten Kreuzes" },
  { code: "571", label: "Anhänger Wechselaufbauten" },
  { code: "572", label: "Selbstfahrervermiet-Anhänger" },
  { code: "651", label: "Kraftomnibusse Linienverkehr" },
  { code: "661", label: "Kraftomnibusse Gelegenheitsverkehr" },
  { code: "621", label: "sonstige Kraftomnibusse" },
  { code: "701", label: "Abschleppwagen" },
  { code: "702", label: "Arbeitsmaschinen" },
  { code: "712", label: "Auto-/Mobilkräne" },
  { code: "713", label: "Betonpumpen" },
  { code: "542-am", label: "Anhänger Arbeitsmaschinen" },
  { code: "703", label: "Fahrbare Küchen, Feuerwehrmannschafts- und Gerätewagen" },
  { code: "705", label: "Straßenreinigungs- und Sprengwagen, Müll- und Fäkalienabfuhrwagen" },
  { code: "707", label: "Krankenwagen" },
  { code: "708", label: "Hub- und Gabelstapler über 20 km/h auf beschränkt öffentlichen und öffentlichen Verkehrsflächen" },
  { code: "709", label: "Leichenwagen" },
  { code: "719", label: "Wagnisse, die nicht an anderer Stelle im Tarif genannt sind" },
  { code: "195", label: "Oldtimer-Pkw ohne Vermietung" },
  { code: "095", label: "Oldtimer-Kraftrad ohne Vermietung" },
  { code: "196", label: "Oldtimer-Campingfahrzeug ohne Vermietung" },
  { code: "295", label: "Oldtimer-Lieferwagen ohne Vermietung" },
  { code: "395", label: "Oldtimer-Lastkraftwagen ohne Vermietung" },
  { code: "495", label: "Oldtimer-Zugmaschine ohne Vermietung" },
  { code: "695", label: "Oldtimer-Omnibus ohne Vermietung" },
  { code: "795", label: "Oldtimer-Fahrzeug ohne Vermietung" },
  { code: "496", label: "Oldtimer-Landwirtschaftliche Zugmaschine ohne Vermietung" },
  { code: "595", label: "Oldtimer-Anhänger ohne Vermietung" },
];
